export enum RoamingDeviceProtectionStatus {
  Enabled = "enabled",
  Disabled = "disabled",
}
